var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000180359576346682406060000018278398661343796650_);fill:url(#SVGID_00000132079665957296739470000014919214174984085928_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M144,106.2c1-1,1.4-2.5,0.9-3.9l-25.2-75.7l48.4,22.6l9.8,103.2l-28.4-13.8c-1.2-0.6-2.7-0.5-3.8,0.3 c-1.1,0.8-1.7,2.1-1.5,3.5l11.4,93L115.2,98.1l24.9,8.9c0.4,0.1,0.8,0.2,1.3,0.2C142.3,107.2,143.3,106.9,144,106.2 M110.9,16.7 c-1.1,1-1.5,2.6-1.1,4l25.5,76.7l-24.6-8.8c-1.3-0.5-2.8-0.2-3.8,0.8c-1,1-1.4,2.4-1,3.8l55.3,188.3c0.5,1.6,2,2.7,3.6,2.7 c0.2,0,0.5,0,0.8-0.1c1.9-0.4,3.2-2.2,3-4.1l-16.2-131.6l28.2,13.7c1.2,0.6,2.6,0.5,3.8-0.3c1.1-0.8,1.7-2.1,1.6-3.4L175.4,46.4 c-0.1-1.3-0.9-2.5-2.1-3L115,16.1c-0.5-0.2-1.1-0.3-1.6-0.3C112.5,15.8,111.6,16.1,110.9,16.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036216747850995702760000004647129018789124008_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106844350575726051050000000694348631946158227_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.6512,
    y1: 300.7678,
    x2: 4.3488,
    y2: 300.7678,
    gradientTransform: "matrix(0 333.1858 333.1858 0 -100065.7656 -165.5232)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 15.8,
    style: {
      clipPath: "url(#SVGID_00000036216747850995702760000004647129018789124008_)",
      fill: "url(#SVGID_00000106844350575726051050000000694348631946158227_)"
    },
    width: 80.5,
    height: 268.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.4741b34cd064a14c3130dfd68409b52e.svg";
export { ForwardRef as ReactComponent };